import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import Datatable from "../../components/datatable/Datatable"
import DatatableDB from "../../components/datatable/DatatableDB"

const List = (props) => {
  const { dir } = props;
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        {dir == 'contacts' ?
          <DatatableDB dir={dir} />
          :
          <Datatable dir={dir} />
        }
      </div>
    </div>
  )
}

export default List